"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableActionConfirm_1 = require("../../../../../../shared/components/table_actions/TableActionConfirm");
var TableActionReject_1 = require("../../../../../../shared/components/table_actions/TableActionReject");
var TableActionLockLock_1 = require("../../../../../../shared/components/table_actions/TableActionLockLock");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var FinanceWithdrawList = /** @class */ (function (_super) {
    __extends(FinanceWithdrawList, _super);
    function FinanceWithdrawList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchEmailInput = null;
        _this.searchLoginInput = null;
        _this.searchOuterIdInput = null;
        _this.searchDescriptionInput = null;
        return _this;
    }
    FinanceWithdrawList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    FinanceWithdrawList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                withdraw_status_filter: data.withdraw_status_filter,
                withdraw_type_filter: data.withdraw_type_filter
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            withdraw_status_filter: [],
            withdraw_type_filter: [],
            searchEmailFilter: [],
            searchEmailValue: "",
            isSearchEmail: false,
            searchLoginFilter: [],
            searchLoginValue: "",
            isSearchLogin: false,
            searchOuterIdFilter: [],
            searchOuterIdValue: "",
            isSearchOuterId: false,
            searchDescriptionFilter: [],
            searchDescriptionValue: ""
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    FinanceWithdrawList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    FinanceWithdrawList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    FinanceWithdrawList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadRangeDataByBrandsList({
            brands: this.props.brandsList,
            allBrands: this.props.allBrands,
            Limit: this.state.pageSize,
            Offset: this.getDataOffset(),
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
            allMoneyflowTypes: this.props.allWithdrawTypes,
            moneyflow_types: this.props.withdrawTypesList,
            is_filter_email_part: this.state.isSearchEmail,
            email_part: this.state.searchEmailValue,
            is_filter_login_part: this.state.isSearchLogin,
            login_part: this.state.searchLoginValue,
            is_filter_transaction_part: this.state.isSearchOuterId,
            transaction_part: this.state.searchOuterIdValue
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    FinanceWithdrawList.prototype.onClearDescriptionFilter = function () {
        var _this = this;
        this.setState({
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    FinanceWithdrawList.prototype.onConfirmDescriptionFilter = function () {
        var _this = this;
        this.setState({
            searchDescriptionFilter: [this.state.searchDescriptionValue],
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.onClearEmailFilter = function () {
        var _this = this;
        this.setState({
            searchEmailFilter: [],
            searchEmailValue: "",
            isSearchEmail: false
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.onChangeEmailFilter = function (e) {
        this.setState({ searchEmailValue: e.target.value });
    };
    FinanceWithdrawList.prototype.onConfirmEmailFilter = function () {
        var _this = this;
        this.setState({
            searchEmailFilter: [this.state.searchEmailValue],
            isSearchEmail: true
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.onClearLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [],
            searchLoginValue: "",
            isSearchLogin: false
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.onChangeLoginFilter = function (e) {
        this.setState({ searchLoginValue: e.target.value });
    };
    FinanceWithdrawList.prototype.onConfirmLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [this.state.searchLoginValue],
            isSearchLogin: true
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.onClearOuterIdFilter = function () {
        var _this = this;
        this.setState({
            searchOuterIdFilter: [],
            searchOuterIdValue: "",
            isSearchOuterId: false
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.onChangeOuterIdFilter = function (e) {
        this.setState({ searchOuterIdValue: e.target.value });
    };
    FinanceWithdrawList.prototype.onConfirmOuterIdFilter = function () {
        var _this = this;
        this.setState({
            searchOuterIdFilter: [this.state.searchOuterIdValue],
            isSearchOuterId: true
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceWithdrawList.prototype.getColumns = function () {
        var _this = this;
        var _email_filter = this.state.searchEmailFilter;
        var _login_filter = this.state.searchLoginFilter;
        var _outerid_filter = this.state.searchOuterIdFilter;
        var _description_filter = this.state.searchDescriptionFilter;
        return [{
                title: 'Дата',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 150,
            }, {
                title: 'Игрок/Партнер',
                dataIndex: this.props.data.dk_player_login,
                key: this.props.data.dk_player_login,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchLoginInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043B\u043E\u0433\u0438\u043D\u0443", value: _this.state.searchLoginValue, onChange: _this.onChangeLoginFilter.bind(_this), onPressEnter: function () { _this.onConfirmLoginFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmLoginFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearLoginFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _login_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_login.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchLoginInput.focus();
                        });
                    }
                },
                render: function (text, record, idx) {
                    if (record.partner_id > 0) {
                        return (React.createElement("div", null,
                            " ",
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "user-tie" }),
                            "  ",
                            record.partner_login,
                            " "));
                    }
                    else {
                        return (React.createElement("div", null,
                            "  ",
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "user" }),
                            " ",
                            record.player_login,
                            " "));
                    }
                }
            }, {
                title: 'EMail',
                dataIndex: this.props.data.dk_player_email,
                key: this.props.data.dk_player_email,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchEmailInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E EMail", value: _this.state.searchEmailValue, onChange: _this.onChangeEmailFilter.bind(_this), onPressEnter: function () { _this.onConfirmEmailFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmEmailFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearEmailFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _email_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_email.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchEmailInput.focus();
                        });
                    }
                },
                render: function (text, record, idx) {
                    if (record.partner_id > 0) {
                        return (React.createElement("div", null,
                            " ",
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "user-tie" }),
                            "  ",
                            record.partner_email,
                            " "));
                    }
                    else {
                        return (React.createElement("div", null,
                            "  ",
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "user" }),
                            " ",
                            record.player_email,
                            " "));
                    }
                }
            }, {
                title: 'Транзакция',
                dataIndex: this.props.data.dk_outer_transaction_id,
                key: this.props.data.dk_outer_transaction_id,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchOuterIdInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438", value: _this.state.searchOuterIdValue, onChange: _this.onChangeOuterIdFilter.bind(_this), onPressEnter: function () { _this.onConfirmOuterIdFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmOuterIdFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearOuterIdFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _outerid_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.outer_transaction_id.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchOuterIdInput.focus();
                        });
                    }
                }
            }, {
                title: 'Тип',
                dataIndex: this.props.data.dk_withdraw_type_title,
                key: this.props.data.dk_withdraw_type_title,
                width: 200,
                filters: this.state.withdraw_type_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.withdraw_type_title.includes(value); },
            }, {
                title: 'Основание',
                dataIndex: this.props.data.dk_withdraw_basis_title,
                key: this.props.data.dk_withdraw_basis_title,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.withdraw_basis_title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Сумма',
                dataIndex: this.props.data.dk_amount_in_withdraw_currency_without_comission,
                key: this.props.data.dk_amount_in_withdraw_currency_without_comission,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.amount_in_player_currency_without_comission),
                        " ",
                        record.player_currency_title));
                }
            }, {
                title: 'Статус',
                dataIndex: this.props.data.dk_withdraw_state_title,
                key: this.props.data.dk_withdraw_state_title,
                render: function (text, record, idx) {
                    if (record.withdraw_state_complete) {
                        return (React.createElement("div", { style: { color: "#008000", fontWeight: "bold" } }, record.withdraw_state_title));
                    }
                    if (record.withdraw_state_error) {
                        return (React.createElement("div", { style: { color: "#FF0000", fontWeight: "bold" } }, record.withdraw_state_title));
                    }
                    return (React.createElement("div", null, record.withdraw_state_title));
                },
                width: 150,
                filters: this.state.withdraw_status_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.withdraw_state_title.includes(value); },
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null, _this.getActionButtons(record))); },
                width: 110
            }];
    };
    FinanceWithdrawList.prototype.onConfirmClick = function (record) {
        var _this = this;
        this.props.data.DoMarkWithdrawalConfirmed(record.key, function () {
            _this.loadData(_this.props, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ",
                    React.createElement("b", null,
                        "[",
                        record.key,
                        "]"),
                    " \u0431\u044B\u043B\u0430 \u043F\u043E\u043C\u0435\u0447\u0435\u043D\u0430 \u043A\u0430\u043A \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u0430\u044F"));
            });
        });
    };
    FinanceWithdrawList.prototype.onRejectClick = function (record) {
        var _this = this;
        this.props.data.DoMarkWithdrawalRejected(record.key, function () {
            _this.loadData(_this.props, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ",
                    React.createElement("b", null,
                        "[",
                        record.key,
                        "]"),
                    " \u0431\u044B\u043B\u0430 \u043F\u043E\u043C\u0435\u0447\u0435\u043D\u0430 \u043A\u0430\u043A \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043D\u0430\u044F"));
            });
        });
    };
    FinanceWithdrawList.prototype.getActionButtons = function (record) {
        var _this = this;
        var _ret = [];
        if (record.withdraw_state_code == 1) {
            _ret.push(React.createElement(TableActionConfirm_1.default, { nocircleicons: true, hint: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C", confirmText: "\u042D\u0422\u041E \u0414\u0415\u0419\u0421\u0422\u0412\u0418\u0415 \u041F\u0420\u041E\u0421\u0422\u041E \u0418\u0417\u041C\u0415\u041D\u0418\u0422 \u0421\u0422\u0410\u0422\u0423\u0421 \u0412\u042B\u041F\u041B\u0410\u0422\u042B \u041D\u0410 \u041F\u041E\u0414\u0422\u0412\u0415\u0420\u0416\u0414\u0415\u041D! \u041F\u041B\u0410\u0422\u0415\u0416 \u041F\u0420\u041E\u0412\u0415\u0414\u0415\u041D \u041D\u0415 \u0411\u0423\u0414\u0415\u0422! \u041F\u041E\u0414\u0422\u0412\u0415\u0420\u0416\u0414\u0410\u0415\u0422\u0415 ?", onClick: function () { _this.onConfirmClick(record); }, key: "ab_1" }));
            _ret.push(React.createElement(TableActionReject_1.default, { nocircleicons: true, hint: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C", confirmText: "\u042D\u0422\u041E \u0414\u0415\u0419\u0421\u0422\u0412\u0418\u0415 \u041F\u0420\u041E\u0421\u0422\u041E \u0418\u0417\u041C\u0415\u041D\u0418\u0422 \u0421\u0422\u0410\u0422\u0423\u0421 \u0412\u042B\u041F\u041B\u0410\u0422\u042B \u041D\u0410 \u041E\u0422\u041C\u0415\u041D\u0415\u041D! \u041F\u041B\u0410\u0422\u0415\u0416 \u041F\u0420\u041E\u0412\u0415\u0414\u0415\u041D \u041D\u0415 \u0411\u0423\u0414\u0415\u0422! \u041F\u041E\u0414\u0422\u0412\u0415\u0420\u0416\u0414\u0410\u0415\u0422\u0415 ?", onClick: function () { _this.onRejectClick(record); }, key: "ab_2" }));
        }
        else {
            _ret.push(React.createElement(TableActionLockLock_1.default, { disabled: true, confirmText: "\u042D\u0422\u041E \u0414\u0415\u0419\u0421\u0422\u0412\u0418\u0415 \u041F\u0420\u041E\u0421\u0422\u041E \u0418\u0417\u041C\u0415\u041D\u0418\u0422 \u0421\u0422\u0410\u0422\u0423\u0421 \u0412\u042B\u041F\u041B\u0410\u0422\u042B \u041D\u0410 \u041F\u041E\u0414\u0422\u0412\u0415\u0420\u0416\u0414\u0415\u041D! \u041F\u041B\u0410\u0422\u0415\u0416 \u041F\u0420\u041E\u0412\u0415\u0414\u0415\u041D \u041D\u0415 \u0411\u0423\u0414\u0415\u0422! \u041F\u041E\u0414\u0422\u0412\u0415\u0420\u0416\u0414\u0410\u0415\u0422\u0415 ?", onClick: function () { }, key: "al_1" }));
            _ret.push(React.createElement(TableActionLockLock_1.default, { disabled: true, confirmText: "\u042D\u0422\u041E \u0414\u0415\u0419\u0421\u0422\u0412\u0418\u0415 \u041F\u0420\u041E\u0421\u0422\u041E \u0418\u0417\u041C\u0415\u041D\u0418\u0422 \u0421\u0422\u0410\u0422\u0423\u0421 \u0412\u042B\u041F\u041B\u0410\u0422\u042B \u041D\u0410 \u041E\u0422\u041C\u0415\u041D\u0415\u041D! \u041F\u041B\u0410\u0422\u0415\u0416 \u041F\u0420\u041E\u0412\u0415\u0414\u0415\u041D \u041D\u0415 \u0411\u0423\u0414\u0415\u0422! \u041F\u041E\u0414\u0422\u0412\u0415\u0420\u0416\u0414\u0410\u0415\u0422\u0415 ?", onClick: function () { }, key: "al_2" }));
        }
        return _ret;
    };
    FinanceWithdrawList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.loadData(_this.props);
        });
    };
    FinanceWithdrawList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    FinanceWithdrawList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    FinanceWithdrawList.prototype.onWithdrawTypeFilterChanged = function (allWithdrawTypes, WithdrawTypeCode, Action) {
        if (this.props.onWithdrawTypeFilterChanged) {
            this.props.onWithdrawTypeFilterChanged(allWithdrawTypes, WithdrawTypeCode, Action);
        }
    };
    FinanceWithdrawList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    FinanceWithdrawList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allWithdrawTypes, availBrands: this.props.availWithdrawTypes, captions: { checkbox: "Все типы снятий: ", placeholder: "Выберите тип снятия" }, selectedBrands: this.props.withdrawTypesList, onBrandFilterChanged: this.onWithdrawTypeFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    if (!record.withdraw_state_error) {
                        return (React.createElement("div", null,
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                " [",
                                record.key,
                                "] "),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                                " [",
                                record.date_added.format(_this.state.dtFormat),
                                "] "),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                                " [",
                                record.date_changed.format(_this.state.dtFormat),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                                " [",
                                record.description,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E:"),
                                " [",
                                record.player_balance_before,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435:"),
                                " [",
                                record.player_balance_after,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                                " [",
                                record.description,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0435\u043D\u0430 (\u0441\u043D\u044F\u0442\u0438\u0435 - \u0438\u0433\u0440\u043E\u043A):"),
                                " [",
                                record.exchange_rate_withdraw_to_player,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0417\u0430\u043F\u0440\u043E\u0441:"),
                                " [",
                                record.withdraw_req,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041E\u0442\u0432\u0435\u0442:"),
                                " [",
                                record.withdraw_resp,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0434\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u044B:"),
                                " [",
                                record.withdraw_data,
                                "]")));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                " [",
                                record.key,
                                "] "),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                                " [",
                                record.date_added.format(_this.state.dtFormat),
                                "] "),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                                " [",
                                record.date_changed.format(_this.state.dtFormat),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                                " [",
                                record.description,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E:"),
                                " [",
                                record.player_balance_before,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435:"),
                                " [",
                                record.player_balance_after,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                                " [",
                                record.description,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0435\u043D\u0430 (\u0441\u043D\u044F\u0442\u0438\u0435 - \u0438\u0433\u0440\u043E\u043A):"),
                                " [",
                                record.exchange_rate_withdraw_to_player,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0417\u0430\u043F\u0440\u043E\u0441:"),
                                " [",
                                record.withdraw_req,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041E\u0442\u0432\u0435\u0442:"),
                                " [",
                                record.withdraw_resp,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0434\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u044B:"),
                                " [",
                                record.withdraw_data,
                                "]"),
                            React.createElement("div", { style: { color: "#FF0000", fontWeight: "bold" } },
                                "\u0421\u0422\u0410\u0422\u0423\u0421: ",
                                React.createElement("b", null, "\u041E\u0428\u0418\u0411\u041A\u0410")),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E \u043E\u0442\u043C\u0435\u043D\u044B \u043F\u043B\u0430\u0442\u0435\u0436\u0430:"),
                                " [",
                                record.on_reject_player_balance_before,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435 \u043E\u0442\u043C\u0435\u043D\u044B \u043F\u043B\u0430\u0442\u0435\u0436\u0430:"),
                                " [",
                                record.on_reject_player_balance_after,
                                "]")));
                    }
                }, scroll: { x: true } })));
    };
    return FinanceWithdrawList;
}(React.Component));
exports.default = FinanceWithdrawList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_withdraws_list/ui/component/FinanceWithdrawList.tsx
// module id = 1992
// module chunks = 0